// Production URL
const production = {
  // url: 'https://suyool.money/CorporatePortalApi/api'
  // url: 'https://merchantcorporateapi.suyool.net/api',
  url: 'https://merchantcorporateapi.suyool.money/api',
  // url: 'http://10.20.80.62/corporateAPi/api'
};

// Development URL
const development = {
  url: 'https://merchantcorporateapi.suyool.money/api',
  // url: 'https://merchantcorporateapi.suyool.net/api',
  // url: 'https://localhost:44342/api',
  // url: 'http://10.20.80.62/corporateAPi/api'
};

export const isDevMode = process.env.NODE_ENV === "production";

export const checkQrStatusTimer = 3000;
export const qrTimeoutMinutes = isDevMode ? 1 : 1;
export const DefaultLocation = { lat: 35.1264, lng: 33.4299 };
export const config = isDevMode ? development : production;
